import React from 'react';

const Additionalinformation = () => {
    return (
        <div>
            
        </div>
    )
}

export default Additionalinformation;
